import { Store, select } from '@ngrx/store';
import { State } from '@app/store/state/state';
import { Injectable } from '@angular/core';
import { Observable, map } from 'rxjs';

import { refreshSearchSelector } from '@shared/refresh-search/store/selectors/refresh-search.selector';
import { setRefreshTimerAction } from '@shared/refresh-search/store/actions/refresh-search.actions';

@Injectable()
export class RefreshSearchFacade {

  constructor(
    private readonly store: Store<State>
  ) { }

  public refreshTimer$: Observable<boolean> = this.store.pipe(
    select(refreshSearchSelector),
    map(state => state.refreshTimer)
  );

  public setRefreshTimer(refreshed: boolean): void {
    this.store.dispatch(setRefreshTimerAction({ refreshed }));
  }

}
